var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerOutBox"},_vm._l((_vm.headerTitleArrProp),function(item,index){return _c('div',{key:index,staticClass:"headerItem flexFullBox"},[_c('div',{staticClass:"widthCompare"},[_vm._v(" "+_vm._s(item)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }